/* =============================================================================
 * CoachSurfaceTheme — marks the document while a coach page is on screen
 * -----------------------------------------------------------------------------
 * One line of state, mounted once inside the router: while the coach is on a
 * /coach/* page the document element carries data-aps-surface="coach", and
 * styles/tokens.css darkens the filled-CTA orange for that surface so its white
 * label clears WCAG AA (3.31:1 -> 4.61:1). Nothing else keys off the attribute
 * yet; anything that is coach-only and token-driven can.
 *
 * It is an attribute rather than a wrapper element on purpose: the coach pages
 * render inside the SHARED app shell, and several of their overlays (the modal,
 * the toast) escape the page's own DOM subtree — a CSS variable set at :root
 * reaches those too.
 * ========================================================================== */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ATTR = 'data-aps-surface';

export const CoachSurfaceTheme: React.FC = () => {
  const { pathname } = useLocation();
  const isCoach = pathname === '/coach' || pathname.startsWith('/coach/');

  useEffect(() => {
    const root = document.documentElement;
    if (isCoach) root.setAttribute(ATTR, 'coach');
    else root.removeAttribute(ATTR);
    return () => root.removeAttribute(ATTR);
  }, [isCoach]);

  return null;
};

export default CoachSurfaceTheme;
